// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"850":"e4e8e63c","865":"f1c35f86"}[chunkId] + ".chunk.js";
};